import { Ticket } from "callable-data-objects";
import DDIClassification from "Components/Shared/DDIClassification";
import React from "react";
import { Table } from "semantic-ui-react";
type AssignmentDetailsProps = {
  ticket: Ticket;
};
const GlobalNumberDetails = ({ ticket }: AssignmentDetailsProps) => {
  return (
    <Table size='small' padded={false} singleLine basic stackable>
      <Table.Body>
        <Table.Row>
          <Table.Cell>DDIs</Table.Cell>
          <Table.Cell>
            <ul>
              {ticket.globalNumberRequest.originalDDIs.split("\n").map((s) => (
                <li style={{ listStyle: "none" }}>{s}</li>
              ))}
            </ul>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Classification</Table.Cell>
          <Table.Cell>
            <DDIClassification
              classification={ticket.globalNumberRequest.classification}
            />
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Carrier</Table.Cell>
          <Table.Cell>{ticket.globalNumberRequest.carrier}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export default GlobalNumberDetails;
